import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import useMutation from '@pkg/graphql/useMutation';

const MERGE = /* GraphQL */ `
  mutation MergeLibraryActivity($input: MergeLibraryActivityInput!) {
    mergeLibraryActivity(input: $input)
  }
`;

/**
 * @return {Function}
 */
export default function useMerge() {
  const { mutateAsync } = useMutation({ mutation: MERGE, throwOnError: false });
  const { enqueueSnackbar } = useSnackbar();

  /**
   * @param {String} source_uuid
   * @param {String} target_uuid
   * @returns {Promise}
   */
  async function mergeActivity(source_uuid, target_uuid) {
    const response = await mutateAsync({ source_uuid, target_uuid });
    // The shared GraphQL client reports errors but resolves the request promise.
    if (response?.errors?.length) {
      throw new Error(
        response.errors[0].message || 'Unable to submit the merge.'
      );
    }
    if (!Object.hasOwn(response?.data ?? {}, 'mergeLibraryActivity')) {
      throw new Error(
        'Unable to confirm whether the merge was submitted. Please refresh the library before trying again.'
      );
    }
    enqueueSnackbar(
      'Your activity merge has been queued. The library will update when it finishes.'
    );
    return response;
  }

  return useCallback(mergeActivity, [mutateAsync, enqueueSnackbar]);
}
